import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api } from 'api'
import { toaster } from 'uikit/Toaster'

export const useApproveIdentification = (id: string) => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data) => api.identifications.approveIdentification(id, data),
    onError: (error) => {
      toaster.create({
        title: 'Не удалось изменить статус пользователя',
        description: error?.message,
        type: 'error',
        duration: 9000,
        isClosable: true,
      })
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['userCard'] })
      toaster.create({
        title: 'Готово',
        description: 'Пользвательл успешно подтвержден',
        type: 'success',
      })
    },
  })
}
